import * as React from 'react';
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import IconButton from '@mui/joy/IconButton';
import Box from '@mui/joy/Box';
import ListSubheader from '@mui/material/ListSubheader';
import { useContext,useEffect,useState } from 'react';
import { ContextFromSelections, FetchedDataContext } from './Context';
import { FormControl,Typography } from '@mui/material';
import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone';




export default function SelectFont() {
    
  const action = React.useRef(null);
  const [selectedData, setSelectedData] = React.useContext(ContextFromSelections)
  const FetchedData = useContext(FetchedDataContext)
  const [value, setValue] = useState(selectedData.font);
  const [RibbonFonts, setRibbonFonts] = useState([]);

  useEffect(() => {
    setRibbonFonts(FetchedData.get("fetchedFontNames"))
  },[FetchedData])
  


  useEffect(() => {
    if (!selectedData.addText) {
      setValue(null)
    }
  },[selectedData.addText])

  return (
   <FormControl>
    <Typography fontSize={12} >Font</Typography>
    <Select
      disabled={!selectedData.addText}
      size='sm'
      action={action}
      value={value}
      placeholder={<Typography fontSize={13}>Select Font</Typography>}
      onChange={(event, newValue) => {
        setSelectedData({...selectedData, font: newValue})
        setValue(newValue)}

      }
    
      {...(value && {
        
        endDecorator: (
          <IconButton
            variant="plain"
            color="neutral"
            onMouseDown={(event) => {
              event.stopPropagation();
            }}
            onClick={() => {
              setValue(null);
              setSelectedData((data) => ({...data,font: null}))
              action.current?.focusVisible();
            }}
          >
            <CloseTwoToneIcon />
          </IconButton>
        ),
        indicator: null,
      })}
      
      sx={{
        
        width:{ xs: 160, sm: 170},
        height: 30,
        fontSize: 18,
        fontStyle: "bold",
        fontFamily: value,
       }}
    >
        
        {RibbonFonts && 
         RibbonFonts.map((element,index) => (
            <React.Fragment key={index}>
            <ListSubheader >{element.language}</ListSubheader>
            <Box
              key={index}
              sx={{
                display:"inline-flex",
                flexWrap: 'wrap',
                width: 300,
                gap: 1,
                paddingLeft: 1
              }
              }>
                {element.fonts.map((font,_) =>
                 <Option
                  key={_}
                  value={font}
                  sx={{fontFamily: font, fontWeight: 550, fontSize: 18, border: "1px solid", borderColor: "divider", borderRadius: "5px",width: 90}}
                   >
                    {element.template_word}
                   </Option>)}
               </Box>
            </React.Fragment>
        ))}
    
    </Select>
   
    </FormControl>
    
  );
}


